import { useEffect, useRef, useState} from "react";
import Matter from "matter-js";
import './spoondrop.css';
import { createMatterEngine } from "./util/createMatterEngine";
import { GameShell } from "./util/GameShell";
import { swapDocBody, useGameState, MAX_HEIGHT, MAX_WIDTH, createPlusScore, getRandomInt, getSpoon, getSpoonWithHilt, 
  getDualSidedSaber, drawHUD, createRandom2DVector, rotatePlayerToward, 
  BACKGROUND_COLOR,
  getAngleBetweenPos,
  getDistanceBetweenPos,
  createDefined2DVector} from "./util/spoonHelper";
  import { createPausableTimerGroup } from "./util/pausableTimers";
  
const SpoonSaberBattle = () => {
  const gameKey = "saberBattle";
  const hudRef = useRef(null);
  const [mobilePlayer, setMobilePlayer] = useState(false);
  const [canvasWidth, setCanvasWidth] = useState(0);
  
  const flavor = "The Soupth are attacking! You must take up your SpoonSaber.";
  const instructions = "Click or tap and drag your SpoonSaber to block the enemy attacks";
  const gameState = useGameState(flavor, instructions, gameKey);
    const { canvasRef, canvasHeight, setCanvasHeight, restartRef, setPlayButtonText,
            setGameOverState, setMessage, setScoreText, recordScore,
          gameStartedRef, rebuildKey, pauseRef, resumeRef,} = gameState;

  const [playerColor, setPlayerColor] = useState(null);
  // const playerColorRef = useRef(playerColor);

  useEffect(() => swapDocBody(), []);

  useEffect( () => {
    var isMobile = false;
    
    const width = Math.min(window.innerWidth, MAX_WIDTH);
    const height = Math.min(window.innerHeight, MAX_HEIGHT);
    setCanvasHeight(height);
    setCanvasWidth(width);

    let Bodies = Matter.Bodies;
    let Body = Matter.Body;
    let Vector = Matter.Vector;
    let Composite = Matter.Composite;
    let Mouse = Matter.Mouse;
    let MouseConstraint = Matter.MouseConstraint;
    let engineOptions = {gravity: {y: 0}};
    const timers = createPausableTimerGroup();
    const { engine, runner, render, start, cleanup } = createMatterEngine(timers, canvasRef, width, height, engineOptions);
    // moves hud to right side of screen
    // const hudCanvas = hudRef.current;
    // if (hudCanvas) {
    //   hudCanvas.width = width;
    //   hudCanvas.height = height;
    // }

  //saber colors
  const lightSideColors = new Map([
    ['yellow', '#ffff00'],
    ['neonGreen', '#b4ff00'],
    ['lime', '#46ff00'],
    ['green', '#00FF00'],
    ['mint', '#00ff3c'],
    ['cyan', '#00ff8c'],
    ['sky', '#008CFF'],
    ['blue', '#0000FF'],
    ['purple', '#7300ff'],
    ['magenta', '#dc00FF']
  ])
  const darkSideColors = new Map([
    ['red', '#ff2727ff'],
    ['bloodOrange', '#ff3c00ff'],
  ])


  var gameWidth = width*4/5;
  var marginX = (width-gameWidth)/2;
  var gameHeight = height*4/5;
  var marginY = (height-gameHeight)/2
  var points = 0;
  var fric = 0.1
  let lives = 3;
  var size = 100; //size var for spoon
  var ragDoll = false;
  var isPlayerDarkSide = false;
  let localColor = getRandomSaberColor(isPlayerDarkSide);
  let saberPathNeeded = false;
      
  function getRandomSaberColor(isDarkSide){
    var colorValuesArray = [...lightSideColors.values()];
    if(isDarkSide){
      colorValuesArray = [...darkSideColors.values()];
    }
    return colorValuesArray[getRandomInt(colorValuesArray.length)];
  }
    setPlayerColor("white");
    // var isPlayerDarkSide = false;

    //mobile augmentations
    if(width < 900){
      fric = 0.03
      isMobile = true;
      size = width > 500 && height > 500 ? 75 : 50;
      if(height > 500){
        setMobilePlayer(true);
      }
    }
    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.2,
          render: {
            visible: false
          }
        }
      });
    
    Composite.add(engine.world, mouseConstraint);

    
      
    const CATEGORY_SPOON = 0x0002;
    const CATEGORY_ENEMY_SPOON = 0x0004;
    const CATEGORY_NOTHING = 0x0000;

    const enemyFilter = {
      category: CATEGORY_ENEMY_SPOON,
      mask: CATEGORY_SPOON,
    };

    const cosmeticFilter = {
      mask: CATEGORY_NOTHING
    }

    const spoonFilter = {
      category: CATEGORY_SPOON,
      mask: CATEGORY_ENEMY_SPOON,
    };
    
    //gamevars init
    var gameStarted = false;
    var resettable = false;
    var isMouseDown = false;
    const spoonStart = {
      x: width/2,
      y: height/2
    }

    function initializePlayer(){
      Composite.remove(engine.world, saber);
      ragDoll = false;
      lives = 3;
      localColor = getRandomSaberColor(isPlayerDarkSide)
      setPlayerColor(localColor);
      saber = getSpoonWithHilt(size, spoonStart.x, spoonStart.y, spoonFilter, localColor);
      if(isPlayerDarkSide){saber = getDualSidedSaber(size*4/5, spoonStart.x, spoonStart.y, spoonFilter, localColor);}
      saber.label = 'playerSaber'
      saber.isSensor = true;
      saber.frictionAir = fric;
      Composite.add(engine.world, saber);
    }
    var saber = getSpoonWithHilt(size, spoonStart.x, spoonStart.y, spoonFilter, localColor);
    if(isPlayerDarkSide){saber = getDualSidedSaber(size*4/5, spoonStart.x, spoonStart.y, spoonFilter, localColor);}
    saber.label = 'playerSaber'
    saber.isSensor = true;
    saber.frictionAir = fric;
    Composite.add(engine.world, saber);
    // Composite.add(engine.world, saber2);

    Matter.Events.on(mouseConstraint, "mousedown", function(event) {
      isMouseDown = true;  
    });

    Matter.Events.on(mouseConstraint, "mouseup", function(event){
      isMouseDown = false;
    });
    
    Matter.Events.on(engine, "collisionStart", function(event) {
      // console.log("colision")
       event.pairs.forEach(pair => {
        saberClash(pair, true);
      });
    });

    const particleCooldown = 4;
    Matter.Events.on(engine, "collisionActive", function(event) {
      event.pairs.forEach(pair => {
        saberClash(pair, false)
      });
    });
    let scoreMult = 1;
    let scoreMultGain = 0.1;
    let scorePerfect = 150;
    let scoreWeak = 100;
    if(isPlayerDarkSide){
      scorePerfect *= (2/3);
      scoreWeak *= (2/3)
    }
    function saberClash(pair, isCollisionStart){
        const { bodyA, bodyB } = pair;
        const bodies = [bodyA, bodyB];
        var collision = pair.collision;

        if ((bodyA.parent.label === 'playerSaber' || bodyB.parent.label === 'playerSaber') &&
          (bodyA.label !== 'hilt' && bodyB.label !== 'hilt')) {
          attacks.forEach(attack => {
            if (attack.hitbox && collision.supports.length > 0) {
              // ✅ Saber clashed with hitbox
              var collisionPoint = collision.supports[0]; 
              //increment score once
              handlePoints(isCollisionStart, attack, bodies, collisionPoint)

              //spawn particles while collision active
              if(attack.particleTracker && attack.particleTracker % particleCooldown === 0){
                spawnClashParticles(collisionPoint.x, collisionPoint.y);
              }
              attack.particleTracker += 1;
              //removeAttack(attack);
            }
          });
        }
    }
    function getPointsScored(attack, bodies){
      let scoreGain = scoreWeak * scoreMult;
      if(bodies.includes(attack.hitbox)){
        attack.beenPerfectHit = true;
        scoreGain = scorePerfect * scoreMult;
        scoreMult += scoreMultGain;
      }
      return Math.trunc(scoreGain);
    }
    //dark side 2 hit check
    function checkValidHit(attack, bodyA, bodyB){
      let validHit = false;
      if(bodyA.label === "topSpoon" || bodyB.label === "topSpoon"){
        if(!attack.beenHit){
          validHit = true;
          attack.beenHit = true;
        }
      }
      if(bodyA.label === "bottomSpoon" || bodyB.label === "bottomSpoon"){
        if(!attack.beenHitSecondSide){
          validHit = true;
          attack.beenHitSecondSide = true
        }
      }
      return validHit;
    }
    function spawnClashParticles(x, y, count = 4) {
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = isMobile ? (2.5 + Math.random() * 2.5) : (5 + Math.random() * 5);
        let radius  = isMobile ? 1.5 : 2

        const particle = Matter.Bodies.circle(x, y, radius, {
          restitution: 0.6,
          friction: 0.05,
          render: { fillStyle: "white" }
        });

        Matter.Body.setVelocity(particle, {
          x: Math.cos(angle) * speed,
          y: Math.sin(angle) * speed
        });

        Composite.add(engine.world, particle);

        // Auto-remove after a short time
        timers.setTimeout(() => Composite.remove(engine.world, particle), 200);
      }
    }
    
    const attackGrowthSpeed = 1.01;
    Matter.Events.on(engine, 'afterUpdate', function() {
      // Apply scaling to the body
      stepAttacks();  
      redrawPlayer();
    });
    function stepAttacks(){
      attacks.forEach(attack => {
        if (attack.size < size) {
          attack.size *= attackGrowthSpeed;
          let oldBody = attack.body;
          let newBody = getSpoonWithHilt(attack.size, attack.initialPosition.x, attack.initialPosition.y, cosmeticFilter, attack.color, "middle");
          Body.setAngle(newBody, attack.angle)
          newBody.isStatic = true;
          newBody.isSensor = true;
          Composite.add(engine.world, newBody); 
          Composite.remove(engine.world, oldBody);
          attack.body = newBody;
        }
        else{
          
          if (attack.outer) Composite.remove(engine.world, attack.outer);
          if (attack.inner) Composite.remove(engine.world, attack.inner);
          startCollisionTimer(attack)
        }
      });
    }
    function startCollisionTimer(attack) {
      if (attack.collided) return; // prevent duplicates
      attack.collided = true;

      const perfectHitbox = Bodies.circle(
        attack.initialPosition.x,
        attack.initialPosition.y,
        size / 5,
        {
          isSensor: true,
          render: { fillStyle: "rgba(255, 255, 255, 0.01)" },
          collisionFilter: enemyFilter
        }
      );
      Body.setCentre(perfectHitbox,Vector.create(attack.initialPosition.x, attack.initialPosition.y - size/10), false)
      Body.setAngle(perfectHitbox, attack.angle);
      attack.hitbox = perfectHitbox;
      Composite.add(engine.world, perfectHitbox);
      
      saberPathNeeded = true;

      attack.weakHitboxTimeout = timers.setTimeout(() => {
        attack.body.collisionFilter.mask = enemyFilter.mask;
        attack.body.collisionFilter.category = enemyFilter.category;
      }, 50);
      // Give the player a limited window to clash
      attack.timeout = timers.setTimeout(() => {
        removeAttack(attack);
      }, 300); // 300ms clash window
    }
    function removeAttack(attack) {
      if(!attack.beenPerfectHit) {scoreMult = 1; }
      if (attack.timeout) timers.clearTimeout(attack.timeout);
      if (attack.weakHitboxTimeout) timers.clearTimeout(attack.weakHitboxTimeout);
      if (attack.outer) Composite.remove(engine.world, attack.outer);
      if (attack.inner) Composite.remove(engine.world, attack.inner);
      if (attack.body) Composite.remove(engine.world, attack.body);
      if (attack.hitbox) Composite.remove(engine.world, attack.hitbox);
      
      if(gameStarted && !(attack.beenHit || attack.beenHitSecondSide)){
        lives = Math.max(0, lives - 1);
        if(lives <= 0) {
          gameOver();
        }
      }
      attacks = attacks.filter(a => a !== attack);
    }
    Matter.Events.on(engine, "beforeUpdate", (evt) => {
      const dt = evt.delta;
      const target = mouse.position;
      if(!ragDoll){
        if(isMouseDown){
          movePlayerToward(target, dt);
        }
        rotatePlayerToward(target, dt, saber, isPlayerDarkSide);
      }
      if(saberPathNeeded === true){
        if(attacks.length>=2){

          createSaberPath(attacks.at(0), attacks.at(1));
          saberPathNeeded = false;
        }
      }
    });
    function redrawPlayer(){
      Composite.remove(engine.world, saber);
      Composite.add(engine.world, saber);
    }

    function movePlayerToward(target, dtMs) {
      const current = saber.position;

      let adjustedTarget = { ...target };

      if (isMobile) {
        // Find angle from saber to target
        const angle = Math.atan2(target.y - current.y, target.x - current.x);

        // Offset backwards along that angle (so saber trails behind finger)
        const distanceBehind = isPlayerDarkSide ? 20 : 40; 
        adjustedTarget.x -= Math.cos(angle) * distanceBehind;
        adjustedTarget.y -= Math.sin(angle) * distanceBehind;
      }

      const desired = {
        x: adjustedTarget.x - current.x,
        y: adjustedTarget.y - current.y,
      };

      const dist = Math.hypot(desired.x, desired.y);
      if (dist < 0.5) return; // small deadzone to stop jitter

      const alpha = 1 - Math.pow(1 - 0.2, dtMs / (1000 / 60)); // ~20% catch-up per frame

      const step = {
        x: desired.x * alpha,
        y: desired.y * alpha,
      };

      Matter.Body.translate(saber, step);
    }


    
    var spawnEnemies;
    var tracker = 0;
    var initialSpeed = 30;
    var speed = initialSpeed;

    function startEnemy(){
      
      const tutEl = document.getElementById("descenttut");
      if (tutEl) tutEl.innerHTML = "";

      spawnEnemies = timers.setInterval(() => {
        if (document.getElementById("dropper") === null || !gameStarted) {
          timers.clearInterval(spawnEnemies);
          return;
        }
        //detectDroppedSpoons()
        if(doSpawnCheck()){
          spawnEnemy();
        }
        if(gameStarted){
          setText();
        }
      }, 100);
    }
        //handles increasing speed of game spawns
    //returns true if spawn should occur
    function doSpawnCheck() {
      if(!gameStarted){
        return false;
      }
      let doSpawn = false;
      //after 12 it's close to max speed
      if (tracker % (3 * speed) === 0 && speed > 25) {
        speed = speed - 5;
        tracker = 0;
      }
      //more gradual speed change to top speed
      else if (tracker % (3 * speed) === 0 && speed > 10) {
        speed--;
        tracker = 0;
      }
      if (tracker % speed === 0) {
        doSpawn = true;
      }
      tracker++;
      return doSpawn; 
    }
    var attacks = [];
    const attackAngleRange = 1.5*Math.PI;
    const innerFactor = 0.98; //size of inner spoon
    const silhouetteInnerFactor = 0.95
    function spawnEnemy(){
      const initialSizeFactor = 0.1;
      const color = getRandomSaberColor(!isPlayerDarkSide);
      const angle = Math.random()*attackAngleRange - attackAngleRange/2 
      let enemyX = Math.random()*gameWidth+marginX;
      let enemyY = Math.random()*gameHeight+marginY;
      //distance between new attacks
      while (attacks.length > 0 && getDistanceBetweenPos(attacks.at(-1).initialPosition, {x: enemyX, y: enemyY}) < size){
        enemyX = Math.random()*gameWidth+marginX;
        enemyY = Math.random()*gameHeight+marginY;
      }
      let evilOuter = getSpoon(size, enemyX, enemyY, cosmeticFilter, color);
      let evilInner = getSpoon(size*innerFactor, enemyX, enemyY, cosmeticFilter, BACKGROUND_COLOR);
      Body.setAngle(evilOuter, angle);
      Body.setAngle(evilInner, angle);
      Composite.add(engine.world, evilOuter)
      Composite.add(engine.world, evilInner)
      let attack = {
        outer: evilOuter,
        inner: evilInner,
        body: getSpoonWithHilt(size*initialSizeFactor, enemyX, enemyY, cosmeticFilter, color), 
        size: initialSizeFactor*size,
        color: color,
        initialPosition: {x: enemyX, y: enemyY},
        collided: false,
        hitbox: null,
        timeout: null,
        weakHitboxTimeout: null,
        beenHit: false,
        beenHitSecondSide: false, //only for dark side dual sided saber
        beenPerfectHit: false,
        particleTracker: 1,
        angle: angle,
        speed: speed
      }
      attacks.push(attack)
      Composite.add(engine.world, attack.body)
    }

    function getEnemySilhouettePart(x, y, angle, color = "#000000"){
      let silSize = color === "#000000" ? size*silhouetteInnerFactor : size;
      let evilInner = getSpoon(silSize, x, y, cosmeticFilter, color);
      Body.setAngle(evilInner, angle);
      return evilInner;
    }
    const MAX_STEP_SIZE = size;
    const MIN_STEP_SIZE = size/5;
    const MAX_STEP_NUM = 8;
    const MIN_STEP_NUM = 1;
    function createSaberPath(prevAttack, curAttack){
      let silNum = getRandomInt(6) + 2;
      let spacialDiff = getDistanceBetweenPos(prevAttack.initialPosition, curAttack.initialPosition);
      let movementAngleDiff = getAngleBetweenPos(prevAttack.initialPosition, curAttack.initialPosition);
      let prevAngle = prevAttack.angle >= 0 ? prevAttack.angle : prevAttack.angle + 2*Math.PI; 
      let nextAngle = curAttack.angle >= 0 ? curAttack.angle : curAttack.angle + 2*Math.PI; 
      let bodyAngleDiff = prevAngle - nextAngle;
      let spacing = spacialDiff/(silNum+1);
      while(spacing > MAX_STEP_SIZE && silNum < MAX_STEP_NUM){
        silNum++;
        spacing = spacialDiff/(silNum+1);
      }
      while(spacing < MIN_STEP_SIZE && silNum > MIN_STEP_NUM){
        silNum--;
        spacing = spacialDiff/(silNum+1);
      }
      if(Math.abs(bodyAngleDiff) < Math.PI/3 && silNum > MAX_STEP_NUM/2){
        bodyAngleDiff = bodyAngleDiff < 0 ? Math.PI*2 - bodyAngleDiff : Math.PI*2 + bodyAngleDiff; 
      }
      let msBetween = speed*100 - 500; //500 is about the time it takes to fully grow attack
      let msStep = msBetween/silNum;
      let angleStep = bodyAngleDiff/(silNum+1);
      let silCounter = 1;
      let pathInterval = timers.setInterval(() => {
        let vec = createDefined2DVector(spacing*silCounter, movementAngleDiff+Math.PI/2);
        let silX = vec.x + prevAttack.initialPosition.x;
        let silY = vec.y + prevAttack.initialPosition.y;
        console.log("creating silhouette at " + silX + ", " + silY);
        let curSilOuter = getEnemySilhouettePart(silX, silY, prevAngle - silCounter*angleStep, curAttack.color);
        Composite.add(engine.world, curSilOuter);
        let curSilInner = getEnemySilhouettePart(silX, silY, prevAngle - silCounter*angleStep);
        Composite.add(engine.world, curSilInner);
        timers.setTimeout(()=> {
        Composite.remove(engine.world, curSilOuter);
        Composite.remove(engine.world, curSilInner);
        }, 300)
        silCounter++;
        if(silCounter > silNum) timers.clearInterval(pathInterval);
      }, msStep)

    }
    
    function startGame() {
      if (gameStarted === false) {
        setGameOverState(false); // Show game over screen
        gameStarted = true;
        gameStartedRef.current = true;
        initializePlayer();
        startEnemy();
      }
    }
    function restartGame() {
      if (resettable === true) {
        setScoreText(0);            // reset score
        
        points = 0;
        resettable = false;
        tracker = 0;
        speed = initialSpeed;
        scorePerfect = 150;
        scoreWeak = 100;
        if(isPlayerDarkSide) {
          scorePerfect *= (2/3);
          scoreWeak *= (2/3)
        }
        startGame();
      }
    }
    function gameOver() {
      recordScore(points);
      setScoreText(points);
      let endMessage = getPopupMessage()
      setMessage(endMessage)            
      gameStarted = false;
      gameStartedRef.current = false;
      resettable = true;
      deathAnimation();
      attacks.forEach(attack => {
        removeAttack(attack);
      });
      let pointType = isPlayerDarkSide ? points + " padawans slain" : "Score: " + points + " points"
      setScoreText(pointType)
      const tutEl = document.getElementById("descenttut");
      if (tutEl) tutEl.innerHTML = "";
      const dropperEl = document.getElementById("dropper");
      if (dropperEl) dropperEl.innerHTML = "";
      timers.setTimeout(() => {
        setGameOverState(true); // Show game over screen
      }, 1100)
      //leaderboards
    }

    function handlePoints(isCollisionStart, attack, bodies, collisionPoint, color = "#FFFFFF") {
      let bodyA = bodies[0];
      let bodyB = bodies[1];
      if(isPlayerDarkSide){//darkside can hit twice
        if(isCollisionStart && (!attack.beenHit || !attack.beenHitSecondSide)){  
          if(checkValidHit(attack, bodyA, bodyB)){
            let scoreGain = getPointsScored(attack, bodies);
            if(attack.beenPerfectHit){color = "#3df13d"}
            if(scoreMult > 2) {color = "rainbow"}
            let offset = !attack.beenHit || !attack.beenHitSecondSide ? size/10 : size/2;
            createPlusScore(timers, attack.initialPosition.x, attack.initialPosition.y-offset, scoreGain, engine.world, true, color);
            spawnClashParticles(collisionPoint.x, collisionPoint.y);
            points += scoreGain;
          }
        }
      }
      else if(isCollisionStart && !attack.beenHit){
        let scoreGain = getPointsScored(attack, bodies);
        if(attack.beenPerfectHit){color = "#3df13dff"}
        if(scoreMult > 2) {color = "rainbow"}
        createPlusScore(timers, attack.initialPosition.x, attack.initialPosition.y-size/2, scoreGain, engine.world, true, color);
        spawnClashParticles(collisionPoint.x, collisionPoint.y);
        points += scoreGain;
        attack.beenHit = true;
      }
    }
    function deathAnimation(){
      ragDoll = true;
      let magnitude = isMobile ? .15 : 2.5
      let angularVel = isMobile ? Math.random()*80-40 : Math.random()*150-75;
      Body.applyForce(saber, saber.position, createRandom2DVector(magnitude));
      Body.setAngularVelocity(saber, angularVel)
    }

    function setText() {
      const dropperEl = document.getElementById("dropper");
      //point tracking messages
      if(points >= 10000){
        if (dropperEl){
          if(isPlayerDarkSide){
            dropperEl.innerHTML = "Muahaha! " + points + " padawans slain";
          }
          else {
            dropperEl.innerHTML = "Whoa! " + points + " points";
          }
        } 
      }
      else if(points >= 5000){
        if (dropperEl){
          if(isPlayerDarkSide){
            dropperEl.innerHTML = "Very good. " + points + " padawans slain";
          }
          else {
            dropperEl.innerHTML = "Nice! " + points + " points";
          } 
        }
      }
      else{
        if (dropperEl){
          if(isPlayerDarkSide){
            dropperEl.innerHTML = "Do it. " + points + " padawans slain";
          }
          else {
            dropperEl.innerHTML = points + " points";
          } 
        }
      }
      // debug
      //if (dropperEl ) dropperEl.innerHTML = "Whoa! " + points + " points. Speed = " + speed;
    }
    function getPopupMessage(){
      let message;
      if(points >= 10000){
        if(isPlayerDarkSide){
          message = "Excellent. From here on you will be known as Darth Spooner"
        }
        else{
          message = "You have fought well. The dark side is at bay for now."
        }
      }
      else if(points >= 5000){
        if(isPlayerDarkSide){
          message = "Dark Siders RULE!!!"
        }
        else{
          message = "Through darkness we prevail."
        }
      }
      else if(isPlayerDarkSide){
        message = "The dark side has no place for weaklings."
      }
      else{
        message = "There is hope for all utensils in this galaxy."
      }
      return message;
    }
      
    function startRestart(setDarkSide){
      isPlayerDarkSide = setDarkSide;
      if(!gameStarted && !resettable){startGame()}
      else{
        restartGame();
      }
      setPlayButtonText("Light Side")
    }
    restartRef.current = startRestart;
    pauseRef.current = () => {
      runner.enabled = false;
      timers.pauseAll();
      setScoreText("Score: " + points + " points")
    };
    resumeRef.current = () => {
      runner.enabled = true;
      timers.resumeAll();
    };

    start(); //matter engine
    drawHUD(() => lives, () => gameStarted, hudRef, () => localColor);
    setGameOverState(true)
  // Cleanup on unmount
    return cleanup;
  }, [canvasRef, restartRef, setCanvasHeight, setGameOverState, setMessage, setPlayButtonText, setScoreText, recordScore, rebuildKey, gameStartedRef, pauseRef, resumeRef]);
  
    return (
      <GameShell gameName="SpoonSaber Battle" canvasRef={canvasRef} gameState={gameState} canvasStyle={{ borderColor: playerColor }}
        gameOverProps={{mobile: mobilePlayer, onRestartDarkSide: () => restartRef.current(true)}}>
        <canvas
          ref={hudRef}
          className="hud"
          style={{
            '--canvas-height': `${canvasHeight}px`,
            '--canvas-width': `${canvasWidth}px`,
            position: "absolute",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
      </GameShell>
  )
  
  
};

export default SpoonSaberBattle;